import { Component, OnInit, ViewChild, ElementRef,Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BillingGeneratorService } from '../../../services/billing-generator.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {
  ColDef, GridApi, GridReadyEvent, RowClassParams, RowStyle,
  ClientSideRowModelModule, RowGroupingModule, ModuleRegistry, RowGroupingDisplayType, UseGroupTotalRow
} from 'ag-grid-enterprise';
import * as dayjs from 'dayjs';
import * as tz from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import * as duration from 'dayjs/plugin/duration';


//ModuleRegistry.registerModules([
//  ClientSideRowModelModule,
//  RowGroupingModule
//])

dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(duration);
import { marked } from 'marked';

@Component({
  selector: 'app-billing-qb-refresh',
  templateUrl: './billing-qb-refresh.component.html',
  styleUrls: ['./billing-qb-refresh.component.css']
})

export class BillingQbRefreshComponent implements OnInit {
  @ViewChild('dt_from') dt_from!: ElementRef<HTMLInputElement>;
  @ViewChild('dt_thru') dt_thru!: ElementRef<HTMLInputElement>;
  @Input() isInline = true;

  columnDefs: ColDef[] = [];
  columnDefsList: ColDef[] = [];
  ddSettingsClients: IDropdownSettings = {};
  ddSettingsPeriod: IDropdownSettings = {};

  dtFrom = "2025-12-01";
  dtThru = "2025-12-31";
  currentPeriod = "1";
  clientList: any[] = [];
  errorMsg = "";
  gridApi!: GridApi<any>;
  listInvoices: any[] = [];
  rowData: any[] = [];
  rowSelection: any = "single";
  selectedClients: any[] = [];
  filterClients: any[] = [];
  filterPeriods: any[] = [];
  token = "";
  isContentLoaded = false;
  showModal = "none";
  showMinutesSaved = true;
  showMinutesEditor = true
  authUser = sessionStorage.getItem('wOSAuthUser');
  authAdmin = sessionStorage.getItem('wOSAdmin');
  userID = this.authUser;
  markdownContent = '';

  groupColumnDef: ColDef = { minWidth: 150, headerName: "Entry Date", cellRenderer: "agGroupCellRenderer" };
  groupDefaultExpanded = 0;
  groupTotalRow: "top" | "bottom" | UseGroupTotalRow = "bottom";
  suppressAggFuncInHeader = true;
  defaultColDef: ColDef = { flex: 1, minWidth: 100 };
  groupDisplayType: RowGroupingDisplayType = "groupRows";
  selectedPeriod = "";
  periodInfo = "";
  constructor(
    private billingService: BillingGeneratorService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    const user: any = sessionStorage.getItem('wOSUser');
    this.token = JSON.parse(user).stsTokenManager.accessToken;

    this.ddSettingsClients = {
      singleSelection: false,
      idField: 'id',
      textField: 'old_name',
      enableCheckAll: true,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      unSelectAllText:"Deselect All"
    };

    this.ddSettingsPeriod = {
      singleSelection: true,
      idField: 'id',
      textField: 'quarter_label',
      enableCheckAll: false,
      allowSearchFilter: false,
      closeDropDownOnSelection: true
    };
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.buildColumnSpec(this.listInvoices);
    this.gridApi.sizeColumnsToFit();
    this.loadUXData();
  }

  loadUXData(): void {
    this.billingService.loadUXData({},this.token)
      .then((data:any) => {
        this.rowData = data.qbrefreshes;
        this.filterClients = data.clients;
        this.filterPeriods = data.periods;

        console.log("dataset", data);
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        })
      })
      .catch((err:any) => console.error('Error loading assets:', err));
  }

  onClientSelect(item: any) {
    console.log("onClientSelect", this.clientList)
    //this.entryForm.taskID = item.id;
    //this.getTaskAssignees();
  }

  onPeriodSelect(item: any) {
    console.log("onPeriodSelect", item.id);
    const periodInfo = this.filterPeriods.find((period: any) => period.id === item.id);
    const fromDate = dayjs(periodInfo.quarter_start).format("MMM D, YYYY");
    const thruDate = dayjs(periodInfo.quarter_end).format("MMM D, YYYY");
    const fromPass = dayjs(periodInfo.quarter_start).format("YYYY-MM-DD");
    const thruPass = dayjs(periodInfo.quarter_end).format("YYYY-MM-DD");

    this.dtFrom = fromPass; 
    this.dtThru = thruPass; 
    this.currentPeriod = item.id;
    this.periodInfo = fromDate + " to " + thruDate;
    
  }

  //showCalendar(ctl: string): void {
  //  console.log("showCalendar")
  //  switch (ctl) {
  //    case 'dt_from':
  //      this.dt_from.nativeElement.showPicker();
  //      break;
  //    default:
  //      this.dt_thru.nativeElement.showPicker();
  //      break;
  //  }
  //}

  //groupRowRendererParams = {
  //  suppressCount: false,
  //  innerRenderer: (params: any) => {
  //    const { value, node } = params;
  //    const aggData = node.aggData || {};
  //    const currencySum = aggData['Account Value'] || 0;
  //    return `<span>${value} (Total: $${currencySum.toLocaleString()})</span>`;
  //  },
  //};


  runQBSync(): void {
    if (this.selectedPeriod == '') {
      alert("Please select a billing period to continue.");
      return;    
    }

    this.gridApi.setGridOption('loading', true);
    this.billingService.runQBRefresh(this.dtFrom, this.dtThru, this.currentPeriod, this.userID!, this.token).then(r => {
      console.log("QB Refresh Batch ID",r.message);
      this.loadUXData();
      this.gridApi.setGridOption('loading', false);
    })
  }
  

  buildColumnSpec(table: any): any {
    const tbl = ['id', 'sync_period', 'dt_sync', 'dt_sync_end', 'sync_owner'];
    const labels: any[] = ['ID', 'Sync Period', 'Sync Start', 'Sync End',  'Run By'];
    const alignments: any[] = ['center', 'center', 'center', 'center', 'left'];
    const widths: any[] = [75,200,200,200,125];
    const hides: any[] = [];
    const expander = 'sync_owner';

    let i = 1;
    this.columnDefs = tbl.map((col) => {
      let returnedColDef = {};

      const baseColDef = {
        cellClass: (alignments[i - 1] !== 'left') ? ['text-' + alignments[i - 1]] : [],
        field: col,
        headerName: labels[i - 1],
        headerTooltip: labels[i - 1],
        headerClass: 'text-center',
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        width: widths[i - 1],
        tooltipField: col,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: (col == expander) ? false : true,
        cellRenderer: this.cellRenderer,
        cellDataType: (col == 'billable') ? 'boolean' : '',
        hide: (hides.includes(col.toLowerCase())) ? true : false
      };

      if (col === 'id') {
        console.log("Batch ID Column")
        returnedColDef = {
          ...baseColDef,
          rowGroup: false,
          hide: false, // show the column
          cellRenderer: (params: any) => {
            // only show date for leaf rows, not group headers
            if (params.node.group) return '';
            return params.value;
          }
        };
      } else if (col.indexOf('dt_') > -1) {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const label = dayjs(params.data[col]).format("DD MMM YYYY hh:mm:ssA");
            return label;
          }
        };
      } else if (col === 'sync_period') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const label = params.data.quarter_label
            return label;
          }
        };
      } else if (col === 'sync_owner') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const label = params.data.owner_name
            return label;
          }
        };
      } else {
        returnedColDef = baseColDef;
      }

      i++;
      return returnedColDef;
    });

    // Custom group row display for batch info
    //this.groupRowRendererParams = {
    //  suppressCount: true,
    //  innerRenderer: (params: any) => {
    //    const { value, node } = params;

    //    console.log("groupRowRendererParams",node)
    //    const batchid = value; // add weekday name to group headers
    //    //const dtstamp = dayjs(value).format('DD MMM');

    //    const batch = this.rowData.find(batch => batch.batch_id == batchid);
    //    console.log("batch record", batch);


    //    let batchCount = 0;
    //    const dtfrom = dayjs(batch.dt_from).format('DD MMM YYYY');
    //    const dtthru = dayjs(batch.dt_thru).format('DD MMM YYYY');
    //    const clientLabel = batch.client_initials
    //    //let total = 0;

    //    // Walk the children and sum durations
    //    node.childrenAfterFilter?.forEach((child: any) => {
    //      console.log("children after",child)
    //      batchCount++
    //    });

    //    return `
    //    <span style="font-weight:normal !important">
    //      <strong class="me-3">Batch ${batchid}</strong> ${dtfrom} - ${dtthru}
    //      <span class="mx-4">${clientLabel}</span>
    //      <span class="mx-4"><span class="badge bg_bone c_greydk">${batchCount}</span></span>
    //    </span>
    //    `;
    //  }
    //};
  }

  onSelectionChanged(event: any): void {
    //if (event.source != "apiSelectAll") { }
    console.log("Selection changed")
  }

  cellRenderer(params: any) {
    let template: any = '';
    switch (params.colDef.field) {
      default:
        template = params.getValue();
        break;
    }
    return template;
  }

  getRowStyle = (params: RowClassParams): RowStyle | undefined => {
    // Apply style to group rows
    if (params.node.group) {
      return {
        backgroundColor: 'var(--welarabonemd)',
        fontWeight: 'bold'
      };
    }

    return undefined;
  };

  toggleModal(mode: string): void {
    this.showModal = (mode === 'show') ? 'block' : 'none';
  }

  trackByFn(index: any, record: any) {
    return record.id
  }
}
